// extracted by mini-css-extract-plugin
export default {"stats":"Stats-module--stats--55c71","price":"Stats-module--price--cd4aa"};